import script from "./ReferAFriendCode.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferAFriendCode.vue?vue&type=script&setup=true&lang=js"

import "./ReferAFriendCode.vue?vue&type=style&index=0&id=61b9f042&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61b9f042"]])

export default __exports__